<div class="cs-main-container" [ngClass]="{'cs-opened': showOpciones || showSeleccionadas}">
    <div [ngClass]="{'title-select': isTitle}" class="cs-handler title-select flex-wrap">
        <div (click)="setVisibility(showOpciones, 'opciones')" class="cs-placeholder" [ngClass]="lblClass"
             title="{{placeholder}}" [innerHTML]="placeholder"></div>
        <div class="cs-handler-controls">
            <div class="csControl" [ngClass]="{'selected': showSeleccionadas}"
                 (click)="setVisibility(showSeleccionadas, 'lista')" *ngIf="seleccionadas.length > 0 && showTags"
                 title="Mostrar lista con seleccionadas">
                <i class="fa fa-fw fa-list"></i>
            </div>
            <div class="csControl" title="Mostrar opciones" (click)="setVisibility(showOpciones, 'opciones')"
                 [ngClass]="{'selected': showOpciones}">
                <i class="fa fa-fw fa-caret-down"></i>
            </div>
        </div>
    </div>
    <div class="cs-inner-container" *ngIf="(showSeleccionadas || showOpciones)">
        <div class="cs-selected-opts" *ngIf="showSeleccionadas && showTags">
            <span class="font-sub1" *ngIf="seleccionadas.length === 0; else showOpciones">No se ha seleccionado ninguna opción</span>
            <ng-template #showOpciones>
                <ul>
                    <li class="cs-selected-option" *ngFor="let sel of seleccionadas">
                        <div *ngIf="parentWChildsList">
                            <label class="cs-selected-option-label">
                                {{sel.label}}
                            </label>
                            <div class="cs-pwc-list-container" *ngIf="sel.childs && sel.childs.length > 0"
                                 (mouseover)="sel.showList=true" (mouseleave)="sel.showList=false">
                                <i class="cs-pwc-list-control fa fa-list-ul"></i>
                                <div class="cs-pwc-list" *ngIf="sel.showList">
                                    <ul>
                                        <li *ngFor="let selChild of sel.childs">
                                            {{selChild.label}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <i class="cs-pwc-list-remove fa fa-close" (click)="removerListItem(sel, $event)"></i>
                        </div>
                    </li>
                </ul>
            </ng-template>
        </div>
        <div class="cs-search-text-wrap" *ngIf="showTextFilter">
            <input type="text" class="cs-search-text" (keyup)="doTextFilter($event)">
        </div>
        <ul class="cs-options-container" *ngIf="showOpciones">
            <!--Elemento para seleccionar todo-->
                <li *ngIf="selectAllVis">
                    <custom-item
                            [item]="{id: 'all', label: 'Seleccionar todo', visible: selectAllVis, selected: selectAllStatus}"
                            (onItemClicked)="onItemClicked($event)"></custom-item>
                </li>
                <hr *ngIf="selectAllVis">
            <!--Fin elemento para seleccionar todo-->
            <li *ngFor="let opt of itemObjs">
                <div class="cs-item" *ngIf="opt.visible">
                    <div *ngIf="multiple; else elseInput">
                        <input class="" #miinput [checked]="opt.selected" (change)="clicked(opt, $event)"
                               type="checkbox"
                               [value]="opt.id"/>
                        <label (click)="miinput.click()">{{opt.label}}</label>
                    </div>
                    <ng-template #elseInput>
                        <label>{{opt.label}}</label>
                    </ng-template>
                    <div class="cs-childs-container">
                        <div *ngFor="let child of opt.childs">
                            <div class="cs-item cs-item-child" *ngIf="child.visible">
                                <div *ngIf="multiple; else childElse">
                                    <input #michildinput class="" [checked]="child.selected"
                                           (change)="clicked(child, $event)" type="checkbox" [value]="child.id"/>
                                    <label (click)="michildinput.click()">{{child.label}}</label>
                                </div>
                                <ng-template #childElse>
                                    <input #michildinput class="" [checked]="child.selected"
                                           (change)="clicked(child, $event)" type="radio" name="simple-custom"
                                           [value]="child.id"/>
                                    <label (click)="michildinput.click()">{{child.label}}</label>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <!--custom-item *ngIf="opt.visible"
                             [item]="opt"
                             (onItemClicked)="onItemClicked($event)"></custom-item-->
            </li>
        </ul>
    </div>
</div>